import React from 'react';

import { setPreviousUrl } from '~src/app/actions/spaces/SetPreviousUrlReducerAction';
import { getAppStore } from '~src/app/AppStore';
import { VizServiceContext } from '~src/app/spaces/VizSpace/VizService';
import { useEffectOnUrlChange } from '~src/root/hooks/UseEffectOnUrlChange';
import { shouldSetPreviousUrl } from '~src/ts/helpers/UrlHelpers';

export function useSetPreviousUrlHandler() {
  const vizService = React.useContext(VizServiceContext);

  useEffectOnUrlChange((newUrl, oldUrl) => {
    if(shouldSetPreviousUrl(oldUrl, newUrl, vizService)) {
      // setting the previous url here keeps the sorts and filter parameters in the url
      getAppStore().dispatch(setPreviousUrl(oldUrl));
    }
  }, [vizService]);
}
